export default "__VITE_ASSET__BUyH$zhs__"